import { Outlet } from '@remix-run/react';
import { InterceptWebViewLinks } from 'buying/helpers/InterceptWebViewLinks';
import { ODTeamBoundary } from 'platform/ODTeamBoundary';

export default function RetailLayout(): RouteComponentOutput {
  return (
    <ODTeamBoundary team="seller">
      <InterceptWebViewLinks />
      <Outlet />
    </ODTeamBoundary>
  );
}
